import _ from 'lodash';
import REST from 'go/requests/rest';
import React, {useEffect, useState} from 'react';
import {Header, Grid, Button} from 'semantic-ui-react';
import Table from './Table';
import RolesAndPermissionsPopup from './RolesAndPermissionsPopup';
import SearchFilterSort from './SearchFilterSort';
import {getFilterResultsForUser} from './utils';
import AddNewTeamMemberModal from './AddNewTeamMemberModal';
import ManageTeamMemberModal from './ManageTeamMemberModal';

const ManagementContainer = ({emailAdr, toggles}) => {
  const [userData, setUserData] = useState([]);
  const [filteredUserData, setFilteredUserData] = useState([]);
  const [filters, setFilters] = useState({});
  const [sortField, setSortField] = useState('lastName');
  const [sortDir, setSortDir] = useState('asc');
  const [eligibleRoleIds, setEligibleRoleIds] = useState([]);
  const [isAddModalOpen, setAddModalOpen] = useState(false);
  const [isManageModalOpen, setManageModalOpen] = useState(false);
  const [userToManage, setUserToManage] = useState({});
  const [signatureTitleInfo, setSignatureTitleInfo] = useState(null);

  const fetchUserData = async () => {
    const userDataRes = await REST.user.getManageableTeamMembers();
    const users = await userDataRes.json();
    setUserData(users);
    filterUsers(users);
  };

  const fetchEligibleRoleIds = async () => {
    const rolesICanAssignRes = await REST.user.getRolesICanAssign();
    setEligibleRoleIds(await rolesICanAssignRes.json());
  };

  const fetchData = () => {
    fetchUserData();
    fetchEligibleRoleIds();
  };

  const handleFilterChange = (filterType, filterValue) => {
    const newFilters = {...filters, [filterType]: filterValue};
    setFilters(newFilters);
  };

  const clearFiltersAndReset = () => {
    setFilters({});
    setSortField('lastName');
    setSortDir('asc');
  };

  const filterUsers = (users) => {
    const filteredUsers = _.filter(users, (user) => {
      const filterResults = getFilterResultsForUser(user, filters);
      return _.reduce(filterResults, (all, current) => all && current, true);
    });

    setFilteredUserData(filteredUsers);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    filterUsers(userData);
  }, [filters]);

  const fetchUserToManage = async (email) => {
    const res = await REST.user.getAllRolesByEmailAdr(email);
    const user = await res.json();
    const permissions = _.flatMap(
      _.map(user.roles, (role) =>
        _.map(
          role.entities,
          (entity) => `${role.entityTypeId}:${entity.entityId}:${role.roleId}`
        )
      )
    );
    const res2 = await REST.user.searchAssignablePermissions(permissions);
    const assignable = await res2.json();
    setUserToManage({...user, permissions, assignable});
  };

  const fetchSignatureTitleInfo = async (email) => {
    const res = await REST.user.getSignatureTitleInfo(email);
    const resJson = await res.json();
    const signatureTitleInfo = _.get(resJson, 'signatureTitleInfo');
    setSignatureTitleInfo(signatureTitleInfo);
  };

  const toggleManageModal = () => setManageModalOpen(!isManageModalOpen);

  const sortReorder = _.includes(toggles, 'disasterSiteNav');

  return (
    <>
      <AddNewTeamMemberModal
        isOpen={isAddModalOpen}
        toggleModal={() => setAddModalOpen(!isAddModalOpen)}
        toggleManageModal={toggleManageModal}
        fetchUserToManage={fetchUserToManage}
        fetchSignatureTitleInfo={fetchSignatureTitleInfo}
        emailAdr={emailAdr}
      />
      <ManageTeamMemberModal
        isOpen={isManageModalOpen}
        toggleModal={toggleManageModal}
        signatureTitleInfo={signatureTitleInfo}
        userToManage={userToManage}
        setUserToManage={setUserToManage}
        eligibleRoleIds={eligibleRoleIds}
        fetchUserData={fetchUserData}
      />
      <Grid>
        <Grid.Row>
          {sortReorder && (
            <Grid.Column computer={4}>
              <SearchFilterSort
                userData={userData}
                handleFilterChange={handleFilterChange}
                clearFiltersAndReset={clearFiltersAndReset}
                filters={filters}
                sortField={sortField}
                setSortField={setSortField}
                sortDir={sortDir}
                setSortDir={setSortDir}
              />
            </Grid.Column>
          )}
          <Grid.Column mobile={16} computer={12}>
            <Grid verticalAlign="bottom">
              <Grid.Row>
                <Grid.Column width={7}>
                  <Header as="h3">Manage my team</Header>
                </Grid.Column>
                <Grid.Column width={4} textAlign="right">
                  <RolesAndPermissionsPopup eligibleRoleIds={eligibleRoleIds} />
                </Grid.Column>
                <Grid.Column width={5} textAlign="right">
                  <Button
                    size="medium"
                    rounded="true"
                    content={'Add new team member'}
                    primary
                    onClick={() => setAddModalOpen(true)}
                    title="Add new team member"
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Table
              userData={_.orderBy(filteredUserData, sortField, sortDir)}
              toggleManageModal={toggleManageModal}
              fetchUserToManage={fetchUserToManage}
              fetchSignatureTitleInfo={fetchSignatureTitleInfo}
            />
          </Grid.Column>
          {!sortReorder && (
            <Grid.Column computer={4}>
              <SearchFilterSort
                userData={userData}
                handleFilterChange={handleFilterChange}
                clearFiltersAndReset={clearFiltersAndReset}
                filters={filters}
                sortField={sortField}
                setSortField={setSortField}
                sortDir={sortDir}
                setSortDir={setSortDir}
              />
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </>
  );
};

export default ManagementContainer;
